import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export const TitleMoreValueOptions = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray3};
  padding-bottom: 20px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 582px;
  padding-left: 5px;
  padding-right: 20px;
  width: 582px;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    min-width: auto;
    width: 100%;
    column-gap: 10px;
  }
`

export const Title = styled.p`
  color: ${({ theme }) => theme?.colors?.text};
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`

export const ContentPayment = styled.div`
  align-items: center;
  display: flex;
  column-gap: 10px;
  row-gap: 5px;
  flex-wrap: wrap;
`

export const PaymentText = styled.p`
  color: ${({ theme }) => theme?.colors?.textColor};
  font-size: 14px;
  font-weight: 500;
  margin: 0;
`

export const BestValue = styled.span`
  align-items: center;
  background-color: ${({ theme }) => theme?.colors?.priceColor};
  border-radius: 4px;
  display: flex;
  color: ${({ theme }) => theme?.colors?.white};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  padding: 0px 5px;
`
type ValueProps = {
  colorGreen?: boolean
  fontSize?: number
  fontWeight?: string
}

export const Description = styled.div`
  color: ${({ theme }) => theme?.colors?.textColor};
  font-size: 14px;
  margin: 0;
  font-weight: 400;
  padding-bottom: 20px;
  min-width: 582px;
  width: 582px;
  overflow-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    min-width: auto;
    width: 100%;
  }
`

export const Value = styled(PaymentText)<ValueProps>`
  color: ${({ theme, colorGreen }) => (colorGreen ? theme?.colors?.priceColor : theme?.colors?.textColor)};
  font-size: ${({ fontSize }) => fontSize || 16}px;
  font-weight: ${({ fontWeight }) => fontWeight || '400'};
  line-height: 22px;

  display: flex;
  align-items: baseline;
  gap: 5px;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    font-size: 12px;
    line-height: 16px;
  }
`

export const CreditCard = styled.div`
  margin-top: 10px;
`

export const ContentValue = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-end;
`
